<template>
  <div class="home">
    <b-card class="mb-4 h-100 animated fadeIn">
      <QuickDrop v-if="!onPremQuickdropUrl" />
      <template v-else>
        <h2>Quick Drop</h2>
        <div class="mb-2 d-flex flex-column flex-md-row">
          <div>
            Drag and drop files here to quickly open them in Nanome next time
            you put on your headset. Your active license has an
            <span class="text-nowrap">Organization-Hosted</span>
            Quick Drop Server, click the button to open it.
          </div>
          <div class="mx-auto mt-4 mt-md-0 mx-md-4 flex-fill">
            <b-btn
              :href="onPremQuickdropUrl"
              target="_blank"
              variant="primary"
              class="mb-0 px-4 text-nowrap"
            >
              Open Quick Drop
            </b-btn>
          </div>
        </div>
      </template>
    </b-card>

    <b-row cols="1" cols-md="3" class="text-center">
      <b-col class="mb-4">
        <b-card class="mb-0 h-100 animated fadeIn">
          <LicenseDetails />
        </b-card>
      </b-col>

      <b-col class="mb-4">
        <b-card class="mb-0 h-100 animated fadeIn">
          <AccountDetails class="mb-5" />
          <BillingDetails />
        </b-card>
      </b-col>

      <b-col class="mb-4">
        <b-card
          no-body
          class="mb-0 p-4 h-100 animated fadeIn text-white bg-primary"
        >
          <GettingStarted />
        </b-card>
      </b-col>
    </b-row>

    <OrgInviteModal />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import AccountDetails from "@/components/home/AccountDetails";
import BillingDetails from "@/components/home/BillingDetails";
import LicenseDetails from "@/components/home/LicenseDetails";
import GettingStarted from "@/components/home/GettingStarted";
import QuickDrop from "@/components/home/QuickDrop";
import OrgInviteModal from "@/components/home/OrgInviteModal";

export default {
  metaInfo: {
    titleTemplate: "Dashboard - %s"
  },

  components: {
    AccountDetails,
    BillingDetails,
    LicenseDetails,
    GettingStarted,
    QuickDrop,
    OrgInviteModal
  },

  computed: {
    ...mapState(["user"]),
    ...mapGetters("user", ["onPremQuickdropUrl"])
  },

  async created() {
    await Promise.all([
      this.$store.dispatch("licenses/using"),
      this.$store.dispatch("licenses/owned"),
      this.$store.dispatch("billing/methods"),
      this.$store.dispatch("billing/nextInvoice")
    ]);
  }
};
</script>
